import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { APIProvider } from '@vis.gl/react-google-maps';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import AppRoutes from './routes/AppRoutes';
import ScrollToTop from './components/common/ScrollToTop';
import { NotificationProvider } from './contexts/NotificationContext';
import NotificationToast from './components/Notifications/NotificationToast';

const googleMapsApiKey = import.meta.env.VITE_GEOLOCATION_KEY;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Router>
          <APIProvider apiKey={googleMapsApiKey} libraries={['places']}>
            <NotificationProvider>
              <ScrollToTop />
              <AppRoutes />
              <NotificationToast />
              <Toaster position="top-right" />
            </NotificationProvider>
          </APIProvider>
        </Router>
      </QueryClientProvider>
    </>
  );
}

export default App;
